<div class="onboarding-popup-wrapper">
  <div
    class="slider-container"
    aria-live="polite"
    aria-atomic="false"
    id="tourSteps"
    *ngIf="customAssets$ | async as customAssets"
  >
    <h3 class="title-container">{{ (customVariables$ | async)[stepsArray[currentStep - 1]?.titleKey] }}</h3>
    <div class="slider-image" aria-hidden="true">
      <img
        *ngIf="customAssets[stepsArray[currentStep - 1]?.imageId]?.file as customAssetImage; else externalImage"
        [src]="customAssetImage"
        alt="step image"
      />
      <ng-template #externalImage>
        <img class="onboarding-tutorial-image" [class]="stepsArray[currentStep - 1].moduleName" />
      </ng-template>
      <div class="slider-image-extra">
        <ten-dummy-follow-button
          class="mt-4 follow-button"
          *ngIf="stepsArray[currentStep - 1]?.moduleName === 'preferences'"
        >
        </ten-dummy-follow-button>
      </div>
    </div>
    <div
      class="slider-text"
      aria-atomic="false"
      [innerHTML]="(customVariables$ | async)[stepsArray[currentStep - 1]?.descriptionKey]"
    ></div>
  </div>

  <div class="bottom-container" aria-live="polite">
    <div
      [style.visibility]="stepsArray.length ? 'visible' : 'hidden'"
      class="steps"
      [attr.aria-label]="'step ' + currentStep + ' of ' + stepsArray.length"
    >
      {{ currentStep + '/' + stepsArray.length }}
    </div>
    <div class="button-container" aria-live="off">
      <button
        mat-icon-button
        (click)="changeStep(0)"
        [disabled]="currentStep === 1"
        [attr.aria-hidden]="currentStep === 1"
        aria-label="previous slide"
        aria-controls="tourSteps"
      >
        <mat-icon>chevron_left</mat-icon>
      </button>
      <button
        #nextButton
        mat-mini-fab
        color="primary"
        (click)="changeStep(1)"
        [disabled]="currentStep === stepsArray.length"
        aria-label="next slide"
        aria-controls="tourSteps"
      >
        <mat-icon>chevron_right</mat-icon>
      </button>
      <button #endButton mat-button aria-live="off" (click)="finalStep()">
        <span *ngIf="currentStep < stepsArray.length" [translate]="'OnBoardingPopup:Skip'">Skip</span>
        <span *ngIf="currentStep === stepsArray.length" [translate]="'OnBoardingPopup:End'">End</span>
      </button>
    </div>
  </div>
</div>
